import { CountryReturnRate } from './returns'

export const TOP_COUNTRIES = 8

// Expects countries sorted by purchases; everything past the top N folds into one "Others" entry
export function withOtherCountries(
  countries: CountryReturnRate[],
  othersLabel: string,
  top = TOP_COUNTRIES
): CountryReturnRate[] {
  if (countries.length <= top) return countries
  const rest = countries.slice(top)
  const itemsPurchased = rest.reduce((acc, c) => acc + c.itemsPurchased, 0)
  const itemsReturned = rest.reduce((acc, c) => acc + c.itemsReturned, 0)
  return [
    ...countries.slice(0, top),
    {
      country: othersLabel,
      itemsPurchased,
      itemsReturned,
      returnRate:
        itemsPurchased > 0
          ? Math.min((itemsReturned / itemsPurchased) * 100, 100)
          : 0
    }
  ]
}
